module.exports = __webpack_public_path__ + "img/title-2@2x.24ff21ee.png";